import { MsdkStyledComponent, styled } from '@msdk/ui'
import type React from 'react'

type ConditionalFieldContainerProps = React.ComponentProps<'div'> & {
  filterField?: boolean
  size?: number
  hasCustomUI?: boolean
}

export const ConditionalFieldContainer: MsdkStyledComponent<ConditionalFieldContainerProps> = styled(
  'div',
)<ConditionalFieldContainerProps>`
  padding: 0;
  ${(props) => props.filterField && `margin-bottom: 0px;`}
  && {
    ${(props) => props.filterField && `padding-bottom: 0;`}
  }
  ${(props) => props.size && `min-width: 220px;`}
  ${(props) => props.size && !(props.filterField && props.hasCustomUI) && `width: ${props.size}ch;`}

  .MuiFormHelperText-root {
    margin-top: 0;
  }

  .MuiFormControl-root {
    ${(props) => props.filterField && `padding-right: 0;`}
  }
`
